import React from "react";
import { Table, Button, Message } from "semantic-ui-react";

export function ListaPracticantes(props) {
  const { alumnosCali, asignarAlumno, desasignarAlumno } = props;
  const alumnosOrdenados = [...alumnosCali].sort((a, b) =>
    a.alumno_data.apellido_paterno.localeCompare(b.alumno_data.apellido_paterno)
  );

  const isAsignarAlumnoDefined = typeof asignarAlumno !== "undefined";
  const isDesasignarAlumnoDefined = typeof desasignarAlumno !== "undefined";

  return (
    <div>
      {alumnosOrdenados.length === 0 ? (
        <Message info>
          <Message.Header>
            {isAsignarAlumnoDefined
              ? "Todos los alumnos de este grupo ya han sido asignados a un asesor."
              : "No tienes alumnos para asesorar de este grupo."}
          </Message.Header>
        </Message>
      ) : (
        <Table className="table-users-admin">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>MATRICULA</Table.HeaderCell>
              <Table.HeaderCell>CURP</Table.HeaderCell>
              <Table.HeaderCell>APELLIDO PATERNO</Table.HeaderCell>
              <Table.HeaderCell>APELLIDO MATERNO</Table.HeaderCell>
              <Table.HeaderCell>NOMBRE</Table.HeaderCell>
              <Table.HeaderCell>ACCIÓN</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {alumnosOrdenados.map((alumno, index) => (
              <Table.Row key={index}>
                <Table.Cell>{alumno.alumno_data.matricula}</Table.Cell>
                <Table.Cell>{alumno.alumno_data.curp}</Table.Cell>
                <Table.Cell>{alumno.alumno_data.apellido_paterno}</Table.Cell>
                <Table.Cell>{alumno.alumno_data.apellido_materno}</Table.Cell>
                <Table.Cell>{alumno.alumno_data.nombre}</Table.Cell>
                <Table.Cell>
                  <Button
                    icon
                    onClick={() => {
                      if (isAsignarAlumnoDefined) {
                        asignarAlumno(alumno.alumno_data, alumno.id);
                      } else if (isDesasignarAlumnoDefined) {
                        desasignarAlumno(alumno.alumno_data, alumno.id);
                      }
                    }}
                    className={
                      isAsignarAlumnoDefined ? "botonEnviar" : "botonEliminar"
                    }
                  >
                    {isAsignarAlumnoDefined
                      ? "Asignar asesorado"
                      : "Desasignar asesorado"}
                  </Button>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      )}
      <div style={{ textAlign: "center", marginTop: "10px" }}>
        <Button.Group></Button.Group>
      </div>
    </div>
  );
}
